import { useDispatch } from "react-redux";
import { showModal } from "../../features/modal/modalSlice";
import { getUserDocImage } from "../../features/user/userSlice";
import styled from "styled-components";

import question from "../../images/svg/question.svg"

import placeholder from "../../images/img/picturePlaceHolder.jpg"

import ehliyet from "../../images/img/ehliyet-karti.jpg"
import kimlik from "../../images/img/kimlik-kart.jpeg"
import srcBelgesi from "../../images/img/src-belgesi.png"
import vergi from "../../images/img/vergi-levhasi.jpg"
import referans from "../../images/img/referans.png"

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 15px;

    .user-document-item{
        display: flex;
        flex-direction: column;
        width: 31%;
        margin-bottom: 10px;
        cursor: pointer;
        background-color: ${({ theme }) => theme.secondaryBgColor};
        
       img{
            width: 100%;
            height: 133px;
            object-fit: cover;
            height: ${({ modal }) => modal && "100px"};
        }

        .user-document-item-name{
            width: 100%;
            background-color: ${({theme})=> theme.secondaryBgColor};
            color: ${({ theme }) => theme.mainTextColor};
            padding: 2px 0;
            text-align: center;
            font-size: 18px;
            font-weight: var(--font-weight-sm);
            font-size: ${({ modal }) => modal && "12px"};
        }
    }

    @media (max-width: 500px){
        display: grid !important;
        grid-template-columns: repeat(2, 1fr);
        .user-document-item{
            width: 100% !important;
        }
    }

`

const ProfileDocsAndImages = ({modal,userData,src}) => {

    const dispatch = useDispatch()

  // kullanıcı fotoya tıkladığında modal içinde büyük olarak göstermek için
    const handleUserDocImage = (image) => {
        if(image){
          dispatch(getUserDocImage(`${src}${image}`))
          dispatch(showModal("image"))
        }
      }
  return (
    <Container modal={modal} >
        <div className="user-document-item">
            <img src={ userData?.kimlik ? `${src}${userData?.kimlik}`: kimlik}  onClick={()=> handleUserDocImage(userData?.kimlik)} alt="Üye Kimlik" />
            <div className="user-document-item-name">Kimlik</div>
        </div>
        <div className="user-document-item">
            <img src={ userData?.ehliyet ? `${src}${userData?.ehliyet}`: ehliyet}  onClick={()=> handleUserDocImage(userData?.ehliyet)} alt="Üye Ehliyet" />
            <div className="user-document-item-name">Ehliyet</div>
        </div>
        <div className="user-document-item">
            <img src={userData?.srcBelgesi ? `${src}${userData?.srcBelgesi}`: srcBelgesi} alt="Üye Sürücü Belgesi" onClick={()=> handleUserDocImage(userData?.srcBelgesi)} />
            <div className="user-document-item-name">SRC</div>
        </div>
        <div className="user-document-item">
            <img src={ userData?.referansFaturası ? `${src}${userData?.referansFaturası}`: referans} alt="Üye Referans Faturası" onClick={()=> handleUserDocImage(userData?.referansFaturası)}/>
            <div className="user-document-item-name">Referans Faturası</div>
        </div>
        <div className="user-document-item">
            <img src={userData?.vergiLevhası ? `${src}${userData?.vergiLevhası}`: vergi} alt="Üye Vergi Levhası" onClick={()=> handleUserDocImage(userData?.vergiLevhası)}/>
            <div className="user-document-item-name">Vergi Levhası</div>
        </div>
        <div className="user-document-item">
            <img src={userData?.digerBelge1 ? `${src}${userData?.digerBelge1}`: placeholder} alt="Üye Belgesi" onClick={()=> handleUserDocImage(userData?.digerBelge1)}/>
            <div className="user-document-item-name">Diğer</div>
        </div>
    </Container>
  )
}

export default ProfileDocsAndImages